import { PaymentHistory as PaymentHistoryView } from './payment-history';
import { PaymentHistoryProvider } from './payment-history.provider';

export const PaymentHistory = () => (
   <PaymentHistoryProvider>
      <PaymentHistoryView />
   </PaymentHistoryProvider>
);

export const FeaturePaymentHistory = PaymentHistory;
